module.exports = __webpack_public_path__ + "static/img/3-Walking on a boat@2x.7704fc48.png";